import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { map, shareReplay, switchMap, take } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { AsamcoAuthService } from '@asamco/base';
import { redirectDestinationName } from 'libs/base/src/lib/auth/auth.consts';

/**
 * a router guard that prevents invoking routes when a user is not logged in
 * will redirect to the login page if such a route is opened anyway.
 * the default setup of the appshell makes sure that all, but a few top routes are
 * authenticated. Details can be seen in app-shell.route
 */
@Injectable({
	providedIn: 'root',
	// deps: [ActivatedRouteSnapshot, Router, AppSettings]
	// deps: [TenantService]
})
export class Al3AuthGuard {
	/**
	 * keep tabs when someone logs in/out  keep this in the component,
	 * and buffer it, so we don't create a new subscription on every call.
	 */
	private readonly isLoggedIn$ = this.authService.isLoggedIn$.pipe(shareReplay(1));

	/**
	 * constructor
	 */
	constructor(private authService: AsamcoAuthService, private httpClient: HttpClient, private router: Router) {}

	canActivateWithBackend(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
		requiredBackend: string
	): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
		return this.isLoggedIn$.pipe(
			take(1),
			switchMap(isLoggedIn => {
				if(isLoggedIn) {
					return combineLatest([this.httpClient.get<boolean>(`usermanagement/checkCanRunLinks`), this.authService.userSession$]).pipe(
						map(([canRunLinks, us]) => canRunLinks && us.loggedInBackends.some(b => b.name === requiredBackend) || this.formatRedirect())
					);
				}
				return of(this.formatRedirect());
			})
		);
	}

	private formatRedirect() {
		return this.router.createUrlTree(['auth', 'login'], {
			queryParams: {
				[redirectDestinationName]: this.router.getCurrentNavigation().extractedUrl.toString(),
			},
		});
	}
}
